import {
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
    GET_SIGN_UP_REGISTRATION_FORM_FAILURE,
    GET_SIGN_UP_REGISTRATION_FORM_SUCCESS,
    GET_SIGN_UP_REGISTRATION_FORM_REQUEST,
} from './actionTypes';

const initialState = {
  success: false,
  loading: false,
  error: '',
  registrationForm: null,
};

const signIn = (state = initialState, {
  type, error, registrationForm,
}) => {
  switch (type) {
    case SIGN_UP_REQUEST:
      return { ...state, loading: true };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case SIGN_UP_FAILURE:
      return { ...state, loading: false, error };

    case GET_SIGN_UP_REGISTRATION_FORM_REQUEST:
      return { ...state, loading: true, registrationForm: null };
    case GET_SIGN_UP_REGISTRATION_FORM_SUCCESS:
      return {
        ...state, loading: false, registrationForm,
      };
    case GET_SIGN_UP_REGISTRATION_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        error,
      };
    default:
      return state;
  }
};

export default signIn;
